"use client";

import { cn } from "utils";
import { EdMarkIcon } from "@/src/components/Tracker/EdMarkIcon";

interface TrackersSetupMeetEdHeaderProps {
  title: string;
  className?: string;
}

export const TrackersSetupMeetEdHeader: React.FC<
  TrackersSetupMeetEdHeaderProps
> = ({ title, className }) => (
  <div
    className={cn("flex items-center gap-3", className)}
    data-testid="trackers-setup-header-view"
  >
    <div
      className="flex size-8 shrink-0 items-center justify-center rounded-full bg-background_brand_overlay20"
      data-testid="trackers-setup-ed-chip"
      aria-hidden
    >
      <EdMarkIcon size={20} data-testid="trackers-setup-ed-icon" />
    </div>
    <p className="headline_regular_s text-content_primary">{title}</p>
  </div>
);
